module.exports = "../dist/img/upper-banner-39.cf9a.jpg";